import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReloadService {

  private reloadSubject = new Subject<void>();
  reload$ = this.reloadSubject.asObservable();
  reload() {
    this.reloadSubject.next();
  }

  private dataSource = new BehaviorSubject<any>([]);
  data$ = this.dataSource.asObservable();

  // Set initial data
  setSupportingDocsDataList(data: boolean) {
    this.dataSource.next(data);
  }

  // Update data
  updateSupportingDocsDataList(updatedData: any[]) {
    this.dataSource.next(updatedData);
  }
  constructor() { }
}
